import { Component, inject, ViewChild } from '@angular/core';
import {
  IonMenu,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonLabel,
  IonIcon,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { apps, logOutOutline, logInOutline } from 'ionicons/icons';
import { NavigationService } from '@core/services/navigation.service';

@Component({
  selector: 'app-mobile-menu',
  standalone: true,
  imports: [
    IonMenu,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonItem,
    IonLabel,
    IonIcon,
  ],
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
})
export class MobileMenuComponent {
  readonly navigationService = inject(NavigationService);

  constructor() {
    addIcons({ apps, logOutOutline, logInOutline });
  }

  @ViewChild('mobileMenu') mobileMenu!: IonMenu;

  toggle(): void {
    this.mobileMenu?.toggle();
  }

  close(): void {
    this.mobileMenu?.close();
  }

  navigateAndClose(path: string): void {
    this.navigationService.navigateTo(path);
    this.close();
  }

  signInAndClose(): void {
    this.navigationService.signIn();
    this.close();
  }

  signOutAndClose(): void {
    this.navigationService.signOut();
    this.close();
  }
}
